import { Col } from './components/Col/Col.js';
import { Row } from './components/Row/Row.js';
import { FLEX_COLUMN_GAP } from './constants.js';
import { FlexContext } from './context.js';
import { type ReactNode, useMemo } from 'react';
import { css, styled } from 'styled-components';

const FlexColumnContainer = styled.div<{ gap: number }>`
  ${({ gap }) => css`
    display: flex;
    flex-direction: column;
    gap: ${gap}px;
  `}
`;

type FlexProps = {
  readonly children: ReactNode;
  readonly gap?: number;
  readonly reversed?: boolean;
};

const Flex = ({
  children,
  gap = FLEX_COLUMN_GAP,
  reversed = false,
}: FlexProps) => {
  const context = useMemo(() => {
    return { gap, reversed };
  }, [gap, reversed]);

  if (gap) {
    return (
      <FlexColumnContainer gap={gap}>
        <FlexContext.Provider value={context}>{children}</FlexContext.Provider>
      </FlexColumnContainer>
    );
  }

  return (
    <FlexContext.Provider value={context}>{children}</FlexContext.Provider>
  );
};

Flex.Row = Row;
Flex.Col = Col;

export { Flex };
